module.exports = __webpack_public_path__ + "MQ.png?8d85548cdced94811cc80cb48250ea3b";